import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { TrustBar } from './components/TrustBar';
import { CoreServices } from './components/CoreServices';
import { TransportationServices } from './components/TransportationServices';
import { MaintenanceServices } from './components/MaintenanceServices';
import { CleaningServices } from './components/CleaningServices';
import { WhyChoose } from './components/WhyChoose';
import { CoverageMap } from './components/CoverageMap';
import { CtaBanner } from './components/CtaBanner';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { FloatingWhatsApp } from './components/FloatingWhatsApp';
export function App() {
  return <div className="min-h-screen bg-navy text-slate-300 font-sans selection:bg-gold/30 selection:text-white" data-id="element-0" data-mp="2whxb3sqftmf6">
      <Navbar data-id="element-1" data-mp="28s2ynca15zvg" />
      <main data-id="element-2" data-mp="23vkvggucm9l8">
        <Hero data-id="element-3" data-mp="23vul23bheeqe" />
        <TrustBar data-id="element-4" data-mp="23u9v6r043jyv" />
        <CoreServices data-id="element-5" data-mp="23ut9zyugts8o" />
        <TransportationServices data-id="element-6" data-mp="23ti8k5ohswkq" />
        <MaintenanceServices data-id="element-7" data-mp="3ikh98cxzsz0k" />
        <CleaningServices data-id="element-8" data-mp="3ij61y35c994p" />
        <WhyChoose data-id="element-9" data-mp="3ihv1ac76whht" />
        <CoverageMap data-id="element-10" data-mp="3mlj6io8cn0zw" />
        <CtaBanner data-id="element-11" data-mp="3mkrefndynled" />
        <Contact data-id="element-12" data-mp="3mk85gw6ag7ch" />
      </main>
      <Footer data-id="element-13" data-mp="3mjg8pi0yg3km" />
      <FloatingWhatsApp data-id="element-14" data-mp="3rc9d24sih9w6" />
    </div>;
}